import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import ContentListing from "@/pages/ContentListing";
const ContentListingRoute = () => <ContentListing contentType="podcasts" pageTitle="Podcasts" pageDescription="Escucha debates de expertos sobre estrategia regulatoria, ensayos clínicos y gestión de calidad en la industria de Life Sciences." />;

export const Route = createFileRoute("/es/podcasts/")({
  head: () => buildRouteHead("/es/podcasts"),
  component: ContentListingRoute,
});

